export default {
	methods: {
		on(target, event, handler, passive = false) {
			target.addEventListener(event, handler, false);
		},
		off(target, event, handler) {
			target.removeEventListener(event, handler);
		},
		/*
		* 找到最近的触发滚动事件的元素
		* @param {Element} element
		* @param {Element} rootElement
		* @return {Element | window}
		*/
		getScrollEventTarget(element, rootParent = window) {
			let currentNode = element;
			// bugfix, see http://w3help.org/zh-cn/causes/SD9013 and http://stackoverflow.com/questions/17016740/onscroll-function-is-not-working-for-chrome
			while (
				currentNode &&
				currentNode.tagName !== 'HTML' &&
				currentNode.tagName !== 'BODY' &&
				currentNode.nodeType === 1 &&
				currentNode !== rootParent
			) {
				const overflowY = this.getComputedStyle(currentNode).overflowY;
                // 寻找离组件顶层元素最近的样式含有overflowY为'scroll/auto'的元素
				if (overflowY === 'scroll' || overflowY === 'auto') {
					return currentNode;
				}
                // 从当前组件的顶层元素往外开始找
				currentNode = currentNode.parentNode;
			}
			return rootParent;
		},
		// 判断元素是否被加入到页面节点内
		isAttached(element) {
			let currentNode = element.parentNode;
			while (currentNode) {
				if (currentNode.tagName === 'HTML') {
					return true;
				}
				if (currentNode.nodeType === 11) {
					return false;
				}
				currentNode = currentNode.parentNode;
			}
			return false;
		},

		// 获取滚动高度
		getScrollTop(element) {
			return 'scrollTop' in element
				? element.scrollTop
				: element.pageYOffset;
		},
		// 设置滚动高度
		setScrollTop(element, value) {
			'scrollTop' in element
				? (element.scrollTop = value)
				: element.scrollTo(element.scrollX, value);
		},
		// 获取元素距离顶部高度
		getElementTop(element) {
			return (
				(element === window ? 0 : element.getBoundingClientRect().top) +
				this.getScrollTop(window)
			);
		},
		getVisibleHeight(element) {
			return element === window
				? element.innerHeight
				: element.getBoundingClientRect().height;
		},
		getDirection(touch) {
			const distanceX = Math.abs(touch.clientX - this.startX);
			const distanceY = Math.abs(touch.clientY - this.startY);
			return distanceX > distanceY
				? 'horizontal'
				: distanceX < distanceY ? 'vertical' : '';
		},
		getComputedStyle: document.defaultView.getComputedStyle.bind(
			document.defaultView
		)
	}
};
